__turbopack_context__.v({
  "eyebrow": "ItSupportServicesCardSection-module__Yn0R9W__eyebrow",
  "heading": "ItSupportServicesCardSection-module__Yn0R9W__heading",
  "section": "ItSupportServicesCardSection-module__Yn0R9W__section",
  "title": "ItSupportServicesCardSection-module__Yn0R9W__title",
});
